import styled from 'styled-components';

// Side menu alinhado com design X/Twitter: flush na esquerda, full-height,
// background var(--cco-bg), border-right hairline. Sem margin/radius.
// overflow visible quando colapsado pra deixar tooltip escapar do
// limite de 64px e aparecer ao lado dos icones.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => !props.open && '64px'};
  height: 100vh;
  margin: 0;
  /* Liquid Glass (iOS Control Center) — receita:
       1. Veil branco-translucido (mesmo no dark, pra dar a sensacao
          de "vidro iluminado" e nao "plastico escuro").
       2. Blur forte + saturate alto + brightness leve — cores do que
          esta atras ficam vivas atraves do vidro.
       3. Inset highlight + sombra externa pra "espessura". */
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(255, 255, 255, 0.35)'
      : 'rgba(255, 255, 255, 0.08)'};
  backdrop-filter: blur(40px) saturate(200%) brightness(1.06);
  -webkit-backdrop-filter: blur(40px) saturate(200%) brightness(1.06);
  /* Pseudo-element pro topo brilhar (luz "vindo de cima" - especular). */
  position: fixed;
  top: 0;
  left: 0;
  align-items: stretch;
  justify-content: flex-start;
  gap: 12px;
  border-radius: 0;
  padding: 14px 0 0;
  overflow: ${(props) => (props.open ? 'hidden' : 'visible')};
  border-right: 1px solid
    ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(255, 255, 255, 0.4)'
        : 'rgba(255, 255, 255, 0.12)'};
  /* Multiplas sombras pra dar a sensacao de vidro com profundidade:
     - inset 1px branco no topo: highlight do reflexo de luz (top)
     - inset 1px branco-alpha no lado esquerdo: contorno claro do vidro
     - inset radial (-1px right): borda interna direita escurece sutil
     - drop shadow lateral: vidro "levitando" sobre o conteudo */
  box-shadow:
    inset 0 1px 0
      ${(props) =>
        props.theme.title === 'light'
          ? 'rgba(255, 255, 255, 0.8)'
          : 'rgba(255, 255, 255, 0.18)'},
    inset 1px 0 0
      ${(props) =>
        props.theme.title === 'light'
          ? 'rgba(255, 255, 255, 0.5)'
          : 'rgba(255, 255, 255, 0.06)'},
    4px 0 24px
      ${(props) =>
        props.theme.title === 'light'
          ? 'rgba(15, 23, 42, 0.08)'
          : 'rgba(0, 0, 0, 0.5)'};
  /* z-index 30: chrome global precisa ficar ACIMA dos controles do mapa
     (FullscreenButton/UpdatedAgo/FitBounds = z-index 5-7) que senao
     vazam por cima do menu quando ele expande no hover. Mantido abaixo
     dos modais (z-index 50) e do scrim de overlay. */
  z-index: 30;

  /* Gradient sutil top->base: simula a luz mais forte em cima
     (reflexo especular) e dissipa pra baixo. Quando NAO ha conteudo
     colorido atras, esse gradient ainda da "vida" ao painel. */
  background-image: linear-gradient(
    180deg,
    ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(255, 255, 255, 0.25)'
        : 'rgba(255, 255, 255, 0.06)'}
      0%,
    transparent 30%
  );
  background-repeat: no-repeat;

  /* Em <=720px o rail da lugar ao BottomNav (touch-first). Hover-to-
     expand nao funciona em touch e os 64px fixos comem espaco no phone. */
  @media (max-width: 720px) {
    display: none;
  }
  animation-name: ${(props) =>
    props.open === true ? 'expand' : props.open === false && 'expandReverse'};
  animation-fill-mode: forwards;
  animation-duration: 0.35s;
  ${(props) =>
    props.open &&
    `box-shadow: none; border-color: var(--cco-line);`}

  /* Footer pra sempre no rodape, independente do conteudo das Options */
  > [data-footer] {
    margin-top: auto;
  }
`;

export const Options = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
`;

export const Option = styled.img`
  width: ${(props) => (props.width ? props.width : '25px')};
  height: ${(props) => (props.height ? props.width : '25px')};
  min-width: ${(props) => !props.width && '25px'};
  min-height: ${(props) => !props.height && '25px'};
  margin: 15px 0;
  ${(props) =>
    props.open && props.play
      ? 'margin: 15px 30px 15px 0'
      : !props.play
      ? 'margin: 15px 0 15px 22px'
      : 'margin: 15px 21px 15px 0'};
  animation-name: ${(props) =>
    props.open === true && props.play
      ? 'spin'
      : props.open === false && props.play && 'spinReverse'};
  animation-duration: 0.35s;
`;

// Slot pra <Icon /> Lucide-style nos itens do menu (Dashboard, Relatorios,
// etc.). Mantem o mesmo footprint visual do <s.Option> img legado:
// 25x25 area, margin 15px 0 15px 22px. Cor herdada via currentColor —
// CSS no parent OptionWrapper controla via $selected/$hover, eliminando
// a necessidade de 3 SVGs (icon + iconWhite + iconGray).
// Icon slot do nav 44x44 com radius 10. Default: $selected aplica
// bg azul-soft (visivel no modo COLAPSADO). No expandido, o
// OptionWrapper sobrescreve pra transparent pra deixar a row toda
// como bg solido escuro.
export const IconSlot = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  margin: 0;
  border-radius: 10px;
  color: ${(props) =>
    props.$selected ? 'var(--cco-blue)' : 'var(--cco-ink-mute)'};
  background: ${(props) =>
    props.$selected ? 'rgba(78, 161, 243, 0.10)' : 'transparent'};
  transition: color 150ms ease, background 150ms ease;
  flex-shrink: 0;

  > svg {
    width: 20px;
    height: 20px;
  }
`;

// OptionWrapper: quando $open=true, vira row full-width com padding e
// pode receber bg dark-blue solido se $selected. Quando colapsado,
// transparent e centralizado.
export const OptionWrapper = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  text-align: left;
  transition: all 150ms;
  color: ${(props) =>
    props.$selected ? '#fff' : 'var(--cco-ink-mute)'};

  ${(props) =>
    props.open
      ? `
        width: 100%;
        margin: 0;
        gap: 14px;
        padding: 10px 16px;
        border-radius: 0;
        ${
          props.$divider
            ? `border-bottom: 1px solid var(--cco-line);`
            : ''
        }
        justify-content: flex-${props.justify || 'start'};
        background: ${props.$selected ? 'var(--cco-blue)' : 'transparent'};

        &:hover {
          background: ${
            props.noHover
              ? 'transparent'
              : props.$selected
              ? 'var(--cco-blue)'
              : 'rgba(255, 255, 255, 0.04)'
          };
        }

        ${
          props.$selected
            ? `
              & ${IconSlot} { color: #fff; background: transparent; }
            `
            : ''
        }
      `
      : `
        width: 100%;
        justify-content: center;
        padding: 2px 0;

        /* Em colapsado (64px) esconde labels e UserContainer. Mantem
           IconSlot/Avatar/ToggleCircle/BubbleNotifications visiveis. */
        & > label,
        & > [data-userinfo] {
          display: none !important;
        }

        /* Left accent bar 3px azul no item ativo (estilo Slack/Discord)
           — fica colado na borda esquerda do sidebar, fora do
           IconSlot 44x44 pra nao desformar o icone. */
        ${
          props.$selected
            ? `
              &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 3px;
                height: 24px;
                background: var(--cco-blue);
                border-radius: 0 2px 2px 0;
              }
            `
            : ''
        }

        &:hover ${IconSlot} {
          background: ${props.noHover ? 'transparent' : 'rgba(255, 255, 255, 0.04)'};
          color: ${props.noHover ? '' : 'var(--cco-ink)'};
        }

        /* Tooltip custom: aparece a direita do icone no hover, sem
           delay do title HTML nativo. Usa o atributo title como
           fonte. Posicionamento absolute relativo ao OptionWrapper. */
        ${
          !props.noTooltip
            ? `
              &[title]:hover::after {
                content: attr(title);
                position: absolute;
                left: calc(100% + 8px);
                top: 50%;
                transform: translateY(-50%);
                background: var(--cco-surface);
                color: var(--cco-ink);
                border: 1px solid var(--cco-line);
                box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4);
                padding: 6px 10px;
                border-radius: 6px;
                font-size: 12px;
                font-weight: 500;
                white-space: nowrap;
                pointer-events: none;
                z-index: 100;
              }
            `
            : ''
        }
      `}

  .react-switch {
    margin: 15px 0 0 15px;
  }
`;

// Secao de "contexto atual" do SideMenu: aparece entre o avatar e o
// Dashboard, mostrando atalhos rapidos pro Cliente/Parque selecionado
// quando o operador esta em outra rota (ex.: Notificacoes). Permite
// um clique pra voltar pro contexto que estava sendo monitorado.
export const ContextSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 4px 8px;
  border-top: 1px solid
    ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0,0,0,0.06)'
        : 'rgba(255,255,255,0.06)'};
  border-bottom: 1px solid
    ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0,0,0,0.06)'
        : 'rgba(255,255,255,0.06)'};
`;

export const ContextItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  width: 100%;
  color: ${(props) => props.theme.colors.label};
  font-size: 11px;
  font-weight: 600;
  transition: background 120ms, color 120ms;

  > svg {
    width: 14px;
    height: 14px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    color: ${(props) => props.theme.colors.lightblue};
    flex-shrink: 0;
  }

  &:hover {
    background: ${(props) => props.theme.colors.darkblue};
    color: ${(props) => props.theme.colors.white};
    > svg {
      color: ${(props) => props.theme.colors.white};
    }
  }
`;

export const ContextLabel = styled.span`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;

  small {
    font-size: 9px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    opacity: 0.7;
  }
  strong {
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: inherit;
  }
`;

// Rodape do side-menu: ConnectionStatus (discreto). Com padding-bottom
// generoso pra subir o indicador acima da barra do SO/dock. data-footer
// e usado pelo Container pra aplicar margin-top: auto e empurrar pro
// rodape independente da altura das Options acima.
export const FooterStack = styled.div.attrs({ 'data-footer': true })`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 6px 28px;
  width: 100%;
  border-top: 1px solid var(--cco-line);
`;

// Botao de toggle do sidebar — circulo 36x36 com chevron blue. Estilo
// subtle (surface + halo blue sutil). Theme-aware: no dark usa gradiente
// escuro; no light usa surface clara — antes era gradiente dark fixo
// que ficava como um disco preto sobre o sidebar claro.
export const ToggleCircle = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(78, 161, 243, 0.35);
  margin: 0 auto;
  cursor: pointer;
  color: var(--cco-blue);
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'radial-gradient(circle at 50% 50%, #ffffff 0%, #f2f6fb 70%, #e9eff6 100%)'
      : 'radial-gradient(circle at 50% 50%, #1a2330 0%, #0e1421 70%, #0a0d14 100%)'};
  box-shadow: ${(props) =>
    props.theme.title === 'light'
      ? '0 0 0 1px rgba(78, 161, 243, 0.1) inset, 0 1px 4px rgba(15, 23, 42, 0.12)'
      : '0 0 0 1px rgba(78, 161, 243, 0.08) inset, 0 2px 8px rgba(0, 0, 0, 0.4)'};
  transition: transform 200ms ease, border-color 200ms ease;

  > svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    transform: scale(1.05);
    border-color: rgba(78, 161, 243, 0.6);
  }
`;

// Logo HIGRA vertical no rodape. Centralizado dentro do sidebar 64px.
// Tamanho menor (18x80) pra garantir que cabe em viewports curtos sem
// ser cortado pelo overflow:hidden do Container. Antes 22x96 ficava
// apertado quando havia muitos itens no menu.
export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  width: 100%;
  max-width: 64px;
  flex-shrink: 0;
`;

export const Logo = styled.img`
  width: 18px;
  height: 80px;
  margin: 6px 0;
  object-fit: contain;
  display: block;
`;

// Avatar legado (img) — preservado pra compat. Usar AvatarSlot no
// SideMenu (Lucide-style line icon).
export const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: ${(props) => (props.open ? '15px 0 15px 15px' : '15px 0 15px 15px')};
`;

// AvatarSlot — circulo Lucide-style com icone "user" line dentro.
// Match com o padrao de ícones X/Twitter (sem PNG, stroke
// currentColor herdado, ringe sutil pra dar peso visual). Tamanho
// 44x44 igual aos IconSlot do nav pra alinhamento vertical.
export const AvatarSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 999px;
  color: var(--cco-ink-mute);
  background: transparent;
  border: 1px solid var(--cco-line);
  flex-shrink: 0;
`;

export const UserContainer = styled.div.attrs({ 'data-userinfo': true })`
  display: flex;
  flex-direction: column;
  margin: 0 4px;
  flex: 1;
  min-width: 0;

  > label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

// Label do nav (Dashboard, Relatorios, etc) — match design X/Twitter.
// Cor herdada do OptionWrapper (que aplica white quando $selected).
// Visibilidade controlada pelo OptionWrapper pai (via prop open).
export const SidemenuLabel = styled.label`
  display: flex;
  font-size: 14px;
  font-weight: 600;
  margin: 0 4px;
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  letter-spacing: 0.01em;
  ${(props) => props.color && `color: ${props.color}`};
  ${(props) => props.size && `font-size: ${props.size}`};
  :hover {
    text-decoration: ${(props) => props.underline && 'underline'};
  }
`;

// Bubble vermelho de contagem de notificacoes — agora renderiza como
// filho do IconSlot (que e position:relative), entao top/right ancoram
// no canto sup-direito do icone do sino. Translate pra metade fora da
// borda da forma "sticker no canto do icone". box-shadow simula
// "corte" do bg ao redor — visual padrao de badge.
export const BubbleNotifications = styled.div`
  position: absolute;
  border-radius: 999px;
  top: 2px;
  right: 2px;
  transform: translate(35%, -35%);
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: var(--cco-red);
  color: #fff;
  display: grid;
  place-items: center;
  line-height: 1;
  box-shadow: 0 0 0 2px var(--cco-bg);
  pointer-events: none;
`;

// Logo wordmark — img horizontal quando o sidebar esta aberto, rotada
// 90deg (vertical bottom-up) quando colapsado. Mesma imagem nos dois
// modos pra consistencia visual; opacidade reduzida pra ficar discreto
// no rodape sem competir com nav items.
export const HigraMark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  opacity: 0.55;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.85;
  }

  > img {
    height: 18px;
    width: auto;
    display: block;
  }

  ${(props) =>
    props.$horizontal
      ? `
        margin-top: 8px;
        > img {
          height: 18px;
        }
      `
      : `
        /* Sidebar colapsado (64px width): mantem horizontal mas
           reduz proporcionalmente pra caber sem rotacao. Original
           86x29 (ratio 2.97:1) -> max-width 44px = altura ~15px. */
        margin-top: 8px;
        > img {
          max-width: 44px;
          height: auto;
        }
      `};
`;

// Versao + build SHA no rodape do sidebar EXPANDIDO. Discreto,
// monospace, abaixo do logo Nexus. Operador consegue identificar
// rapidamente em qual build esta sem precisar voltar pro /login.
export const VersionLabel = styled.button`
  font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, Consolas,
    monospace;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--cco-ink-mute);
  background: transparent;
  border: 0;
  border-radius: 6px;
  padding: 2px 6px;
  cursor: pointer;
  opacity: 0.6;
  user-select: text;
  white-space: nowrap;

  &:hover {
    color: var(--cco-blue);
    background: transparent;
    opacity: 1;
  }
`;

// Header row do sidebar EXPANDIDO — avatar + user info + toggle inline.
// Substitui o stack vertical (toggle separado em cima do avatar) por
// uma row unica como mostra o design. Divider hairline na base separa
// do bloco de nav abaixo. color explicito pra SidemenuLabel (que usa
// color:inherit) nao herdar fundo escuro do body e sumir.
export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px 14px;
  border-bottom: 1px solid var(--cco-line);
  width: 100%;
  box-sizing: border-box;
  color: var(--cco-ink);
`;
